import { HelpCircle } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/assist/ui/button';
import { useSupportDrawer } from '@/contexts/SupportDrawerContext';

export function HelpButton() {
  const { t } = useTranslation('assist');
  const { openDrawer } = useSupportDrawer();
  const label = t('header.help');

  return (
    <Button
      variant="ghost"
      size="icon"
      className="h-9 w-9"
      onClick={() => openDrawer('list')}
      aria-label={label}
      title={label}
    >
      <HelpCircle className="h-4 w-4" />
    </Button>
  );
}
